enum ECandidatePageMenuAction {
  Contact,
  Address,
  Button,
}

export default ECandidatePageMenuAction;
